import React from "react";
import { DropDown } from "../../../commons";
import { clientTypeDropDown } from "../../../../constant/clientDirectoryDropDown";
import Select from "react-select";
import { CalenderIcon } from "../../../Icon";
import ReactDatePicker from "react-datepicker";
import { Label } from "reactstrap";
import moment from "moment";
import { DropDownType } from "../../../../commonTypes/clientDirectoryTypes";
type AppProps = {
  profileSetupDetails: any;
  setProfileSetupDetails: (data: any) => void;
  handleProfileSetupDropDownChange: (data: DropDownType, name: string) => void;
  isDisabled?: boolean;
};
const ProfileSetup = ({
  profileSetupDetails,
  handleProfileSetupDropDownChange,
  setProfileSetupDetails,
  isDisabled,
}: AppProps) => {
  const option = [
    {
      value: "Select...",
      label: null,
    },
  ];

  const handleDateChange = (date: string) => {
    setProfileSetupDetails((prev: any) => {
      return {
        ...prev,
        profileSetup: {
          ...prev.profileSetup,
          inBusinessSince: date === "Invalid date" ? null : date,
        },
      };
    });
  };
  const handleProfileInputChange = (data: any) => {
    setProfileSetupDetails((prev: any) => {
      return {
        ...prev,
        profileSetup: {
          ...prev.profileSetup,
          noOfEmployees: data.target.value,
        },
      };
    });
  };
  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="Tax Year End">Tax Year End</label>
          <Select
            isDisabled={true}
            options={option}
            value={profileSetupDetails?.taxYearEnd}
            onChange={(e) => handleProfileSetupDropDownChange(e, "taxYear")}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="Client Type">Client Type</label>
          <DropDown
            options={clientTypeDropDown}
            value={profileSetupDetails?.clientType}
            handleChange={(e) =>
              handleProfileSetupDropDownChange(e, "clientType")
            }
            disabled={isDisabled}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="Client Type Subcategory">
            Client Type Subcategory
          </label>
          <DropDown
            disabled
            handleChange={(e) =>
              handleProfileSetupDropDownChange(e, "subcategory")
            }
            options={option}
            value={profileSetupDetails?.clientTypeSubcategory}
          />
        </div>
        <div className="col-md-3">
          <label htmlFor="No of Employees">No of Employees</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="number"
              className="form-control"
              name="noOfEmployees"
              onChange={handleProfileInputChange}
              value={profileSetupDetails?.noOfEmployees}
              onWheel={(event) => event.currentTarget.blur()}
              disabled={isDisabled}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3 mt-2">
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <label>In Business Since</label>
              <Label className="m-0 p-0 w-100">
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    profileSetupDetails?.inBusinessSince
                      ? new Date(
                          moment(
                            `${profileSetupDetails?.inBusinessSince}T00:00:00`,
                            "YYYY-MM-DD"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name="dateOfInvoice"
                  placeholderText="Select"
                  className="form-control"
                  disabled={isDisabled}
                  // disabled
                />
                <span
                  className="calender-icon"
                  style={{
                    right: "30px",
                    cursor: "pointer",
                    marginTop: "22px",
                  }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileSetup;
